const toBlob = (base64, meta) => {
  var bin = atob(base64.replace(/^.*,/, ""));
  var buffer = new Uint8Array(bin.length).map((_, i) => bin.charCodeAt(i));
  // Blobを作成
  try {
    var blob = new Blob([buffer.buffer], {
      type: meta
    });
  } catch (e) {
    return false;
  }
  return blob;
};

const Download = {
  install(Vue) {
    /**
     * Start download
     */
    Vue.prototype.$downloadFile = async (fileName, content, meta) => {
      const blob = toBlob(content, meta);

      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const downloadLink = document.createElement("a");

        var url = window.URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = fileName;
        downloadLink.target = "_blank";
        document.body.appendChild(downloadLink);
        downloadLink.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(downloadLink);
      }
    };
  }
};

export default Download;
